import { Component, computed, inject } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { UiModule } from '../../../../components/ui.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { CameraHealthItem } from '../../../../types';
import { UserLoginService } from '../../../../service/user-login.service';

type CellParams = ICellRendererParams<CameraHealthItem>;

@Component({
  selector: 'app-pan-cell-camera-health-actions',
  imports: [UiModule, MatTooltipModule, RouterModule],
  templateUrl: './cell-camera-health-actions.component.html',
  styleUrl: './cell-camera-health-actions.component.scss',
})
export class CellCameraHealthActionsComponent implements ICellRendererAngularComp {
  private userService = inject(UserLoginService);

  private isAdmin = computed(() => this.userService.currentUserIsAdmin());

  public cameraUrl = computed(() => {
    const camera = this.params.data;

    const baseUrl = 'https://console.rhombussystems.com';
    const cameraPath = `/devices/cameras/${camera.provider_camera_id}`;

    // if user is admin, there's a special URL for them
    if (this.isAdmin()) {
      const adminUrl = new URL(`${baseUrl}/partner/s`);
      adminUrl.searchParams.set('org', camera.provider_branch_id);
      adminUrl.searchParams.set('path', cameraPath);
      return adminUrl.toString();
    }

    // regular users (customers) use the standard URL
    return new URL(cameraPath, baseUrl).toString();
  });

  public params!: CellParams;

  agInit(params: CellParams) {
    this.params = params;
  }

  refresh(params: CellParams) {
    this.params = params;
    return true;
  }
}
